<div class="container">
  <div class="row" *ngIf="false">
    <input type="text" placeholder="Search" />
    <span *ngIf="false">
      <button class="primary" [disabled]="isLoading">Filter</button>
      <button class="primary" [disabled]="isLoading" *ngIf="false">
        Export
      </button>
    </span>
  </div>

  <table>
    <tr>
      <th>Name</th>
      <th>Type of User</th>
      <th>Email</th>
      <th>Date created</th>
      <th>Last login</th>
      <th>Market</th>
      <th>Region</th>
      <th>Medical Area</th>
    </tr>
    <tr *ngFor="let user of userData">
      <td>{{ user.name }}</td>
      <td>{{ user.role }}</td>
      <td>{{ user.email }}</td>
      <td>{{ user.created_at | date: "MM/dd/yyyy" }}</td>
      <td>
        {{ user.last_login_at ? (user.last_login_at | date: "MM/dd/yyyy") : "-" }}
      </td>
      <td>{{ user.markets.join(", ") }}</td>
      <td>{{ user.regions.join(", ") }}</td>
      <td>{{ user.therapeutic_areas?.join(", ") }}</td>
    </tr>
    <tr *ngIf="userData.length === 0 && !isLoading">
      <td colspan="7">No users found.</td>
    </tr>
  </table>

  <div *ngIf="isLoading" class="spinner-wrapper">
    <app-spinner
      [display]="true"
      [class]="'spinner-container'"
      [messageToDisplay]="'Loading data...'"
    ></app-spinner>
  </div>
</div>
